/*
 | Foco que sigue al cursor.
 |
 | Publica la posición del ratón relativa al elemento en las CSS vars --mx/--my.
 | Las usan `.spotlight` (halo radial) y `.glow-border` (borde luminoso) en
 | site.css. Delegado en document para que funcione con contenido que Livewire
 | inserte después.
 */
const SELECTOR = ".spotlight, .glow-border";

export default function registerSpotlight() {
    document.addEventListener(
        "mousemove",
        (event) => {
            const target = event.target instanceof Element ? event.target.closest(SELECTOR) : null;

            if (!target) {
                return;
            }

            const rect = target.getBoundingClientRect();

            target.style.setProperty("--mx", `${event.clientX - rect.left}px`);
            target.style.setProperty("--my", `${event.clientY - rect.top}px`);
        },
        { passive: true },
    );
}
